var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.model.afip_ticket)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){$event.stopPropagation();return _vm.printPago(_vm.model)}}},[_c('i',{staticClass:"icon-print"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }